import {
  PLASMIC_CMS_ID,
  PLASMIC_CMS_PUBLIC_TOKEN,
} from "@stadium/shared/src/constants/env-variables";
import { PLASMIC_CMS_API_URL } from "@stadium/services/plasmic/env-variables";

interface PlasmicCMSQueryOptions {
  tableId: string;
  params?: string;
  onlyFirstRow?: boolean;
  /** Next.js Data Cache tags for server-side fetch invalidation via revalidateTag. */
  tags?: string[];
}

const X_PLASMIC_API_CMS_TOKENS = "x-plasmic-api-cms-tokens";

export const fetchPlasmicCMSData = async ({
  tableId,
  params,
  onlyFirstRow = true,
  tags,
}: PlasmicCMSQueryOptions): Promise<any> => {
  try {
    const res = await fetch(
      `${PLASMIC_CMS_API_URL}/${PLASMIC_CMS_ID}/tables/${tableId}/query${
        params ? `?${params}` : ""
      }`,
      {
        method: "GET",
        headers: {
          [X_PLASMIC_API_CMS_TOKENS]: `${PLASMIC_CMS_ID}:${PLASMIC_CMS_PUBLIC_TOKEN}`,
        },
        ...(tags?.length ? { next: { tags } } : { cache: "no-cache" }),
      },
    );

    if (!res.ok) {
      return null;
    }

    const json = await res.json();
    return onlyFirstRow ? json.rows?.[0]?.data || null : json.rows || [];
  } catch {
    return null;
  }
};
